










































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import DepartmentListItem from "../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/DepartmentListItem";
@Component
export default class HeaderComponent extends Vue {
  constructor() {
    super();
  }

  departmentsResponse: WsResponseModel<DepartmentListItem[]> = null;

  created() {
    this.$api.EmployeeService.GetDepartmentsEvent.once(
      this.onGetDepartments.bind(this)
    );
    this.$api.EmployeeService.GetDepartments();
  }
  mounted(){
   
  }
  onGetDepartments(response: WsResponseModel<DepartmentListItem[]>) {
    this.departmentsResponse = response;
    setTimeout(()=>{
       $('#hornavmenu').slicknav();
        $( "div.slicknav_menu" ).addClass( "hidden-lg" );
    },100)
  }
}
